<template>
  <div class="s-card">
    <div v-if="$hasSlotContent($slots['header'])" class="s-card__header">
      <slot name="header" />
    </div>

    <div v-if="$hasSlotContent($slots['default'])" class="s-card__content">
      <slot name="default" />
    </div>

    <div v-if="$hasSlotContent($slots['footer'])" class="s-card__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SCard',
}
</script>

<style scoped lang="scss">
.s-card {
  $--box-shadow-color: rgba(0, 0, 0, 0.12);
  $--card-box-shadow:
    0px 0px 2px 0px $--box-shadow-color,
    0px 4px 12px 0px $--box-shadow-color;
  $--card-border-radius: 1rem;
  $--card-border-color: #e1e2e4;

  background: #fff;
  border-radius: 1rem;
  box-shadow: $--card-box-shadow;

  &__header {
    padding: 0.75rem;
  }

  &__content {
    padding: 1rem 0.75rem;
  }

  &__footer {
    padding: 0.75rem;
    border-top: 1px solid $--card-border-color;
  }
}
</style>
